module.exports = [
	"Megadeth"
];


/*****************
 ** WEBPACK FOOTER
 ** ./metal-band-names.json
 ** module id = 3
 ** module chunks = 0
 **/